module.exports = __webpack_public_path__ + "img/pngegg-600x375.6a69fdfc.png";